import { useSignals } from "@preact/signals-react/runtime";
import { signal } from "@preact/signals-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ChatButton } from "@/features/chat-button";
import { useChats } from "@/providers/chat-provider";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/providers/language-provider";
import { RotateCw } from "lucide-react";
import { setMainMenu, MAIN_MENUS } from "@/pages/layouts/main-header";

// export const sharedData = signal<any>({
//   title: "Dancing Cat",
//   text: "Check out this funny cat!",
//   url: "https://youtu.be/abc123xyz",
// });
export const sharedData = signal<any>(null);

export function SharedDataManager() {
  useSignals();
  const { t } = useTranslation();
  const { chats, selectChat } = useChats();
  // ChatProvider context가 준비되지 않았을 때를 대비
  // let chats;
  // let selectChat;
  // try {
  //   const chatContext = useChats();
  //   chats = chatContext.chats;
  //   selectChat = chatContext.selectChat;
  // } catch (error) {
  //   // context 초기화 중에는 null 반환
  //   return null;
  // }

  const handleSelectChat = (chat: any) => {
    setMainMenu(MAIN_MENUS.CHATS);
    selectChat(chat);
  };

  const handleCancel = () => {
    sharedData.value = null;
  };

  if (!sharedData.value) return null;

  return (
    <div className="fixed inset-0 z-50 bg-background/80 flex items-center justify-center animate-fade-in">
      <div className="flex flex-col bg-background items-center justify-center max-w-sm h-2/3 rounded-md p-2">
        <div className="mb-2">{t("SelectChatToShareData")}</div>
        {chats ? (
          <ScrollArea className="w-full flex-1">
            {chats.all?.map((chat: any) => (
              <ChatButton
                key={chat._id}
                chat={chat}
                variant="ghost"
                onClick={() => handleSelectChat(chat)}
                hasNewMessage={chat.hasNewMessage}
              />
            ))}
          </ScrollArea>
        ) : (
          <div className="w-full flex flex-1 justify-center items-center">
            <RotateCw className="h-6 w-6 animate-spin" />
          </div>
        )}

        <div className="mt-2 w-full flex justify-end">
          <Button onClick={handleCancel}>{t("Cancel")}</Button>
        </div>
      </div>
    </div>
  );
}
